<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="container">
  <div class="claim_header" (click)="$event.stopPropagation()" fxLayout="column">
    <span *ngIf="!task.groupedTask" class="claim_description" i18n="@@claimTitle1">
      Change assignment of user task.
    </span>
    <span *ngIf="task.groupedTask" class="claim_description" i18n="@@claimTitle2">
      Change assignment of group task.
    </span>

    <mat-form-field appearance="outline" class="search-field">
      <mat-label i18n="@@searchTitle">Search</mat-label>
      <fa-icon id="search_icon" matSuffix class="icon" [icon]="faSearch"></fa-icon>
      <input #claimSearchField type="text" matInput />
    </mat-form-field>
  </div>

  <button
    mat-menu-item
    *ngIf="task.groupedTask && task.isClaimed && !claimSearchField.value?.trim()"
    [disabled]="task.status === TaskStatus.CLOSED"
    (click)="releaseTask(task.taskId)"
    class="release-claim"
  >
    <span class="release-claim-text" i18n="@@deleteAssignment">Release Claim</span>
  </button>

  <button
    mat-menu-item
    *ngFor="let employee of availableEmployees | employeeSearch : claimSearchField.value"
    [disabled]="task.status === TaskStatus.CLOSED"
    (click)="claimTask(task, employee)"
  >
    <div fxLayout="row" fxLayoutAlign="start center">
      <span class="task_claimed_initial" *ngIf="getEmployeeShort(employee.name).length > 0">
        {{ getEmployeeShort(employee.name) }}
      </span>
      <div class="task_claimed_icon" *ngIf="getEmployeeShort(employee.name).length === 0">
        <fa-icon [icon]="faUser"></fa-icon>
      </div>
      <span class="menu_text">{{ employee.userName }}</span>
    </div>
  </button>
</div>
